/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { titleize } from "@cd2/tools"

interface IProps<T> {
  sortFields: T[] | readonly T[]
  sort: { by: T; direction: "ASC" | "DESC" | "asc" | "desc" }

  onChange(value: T): void
}

export function SortSelect<T extends string = string>({ sortFields, onChange, sort }: IProps<T>) {
  return (
    <select
      value={sort.by}
      onChange={e => onChange(e.target.value)}
      css={css`
        padding: 8px;
        background: #f5f5f5;
        border-radius: 3px;
        border: 1px solid #ddd;
        font-size: 13px;
      `}
    >
      {sortFields.filter(Boolean).map(sortStr => (
        <option key={sortStr} value={sortStr}>
          {sortStr === sort.by ? (sort.direction.toUpperCase() === "ASC" ? `↓ ` : "↑ ") : ""}
          {titleize(sortStr)}
        </option>
      ))}
    </select>
  )
}
